import { createSlice } from "@reduxjs/toolkit";

const tokenFromStorage = localStorage.getItem("accessToken");
const userFromStorage = localStorage.getItem("userProfile");

const decodeJwtPayload = (token) => {
  if (!token) return null;
  const parts = token.split(".");
  if (parts.length < 2) return null;
  try {
    const payload = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const normalized =
      payload + "=".repeat((4 - (payload.length % 4 || 4)) % 4);
    return JSON.parse(atob(normalized));
  } catch {
    return null;
  }
};

const normalizePermissions = (permissions) => {
  if (!permissions) return [];
  if (Array.isArray(permissions)) return permissions.filter(Boolean);
  if (typeof permissions === "string") {
    try {
      const parsed = JSON.parse(permissions);
      if (Array.isArray(parsed)) return parsed.filter(Boolean);
    } catch {
      // ignore
    }
    return permissions.split(",").map((item) => item.trim()).filter(Boolean);
  }
  return [];
};

const parsedUser = userFromStorage ? JSON.parse(userFromStorage) : null;
const tokenClaims = tokenFromStorage ? decodeJwtPayload(tokenFromStorage) : null;
const permissionsFromClaims = normalizePermissions(tokenClaims?.permissions);

const initialState = {
  token: tokenFromStorage || null,
  user: parsedUser
    ? {
        ...parsedUser,
        permissions:
          parsedUser.permissions && parsedUser.permissions.length
            ? parsedUser.permissions
            : permissionsFromClaims,
      }
    : null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      const { token, user } = action.payload;
      state.token = token || null;
      state.user = user || null;
      if (token) {
        localStorage.setItem("accessToken", token);
      } else {
        localStorage.removeItem("accessToken");
      }
      if (user) {
        localStorage.setItem("userProfile", JSON.stringify(user));
      } else {
        localStorage.removeItem("userProfile");
      }
    },
    logout: (state) => {
      state.token = null;
      state.user = null;
      localStorage.removeItem("accessToken");
      localStorage.removeItem("userProfile");
    },
  },
});

export const { setCredentials, logout } = authSlice.actions;
export default authSlice.reducer;
